import PlanRoutes from './plan.routes';
import ActualRoutes from './actual.routes';
import DragDropPlannerRoutes from './dragdrop-planner.routes';

export default [
  ...PlanRoutes,
  ...ActualRoutes,
  ...DragDropPlannerRoutes,
]
